import { render } from "./symptomInof.vue?vue&type=template&id=f37b2c38&scoped=true"
import script from "./symptomInof.vue?vue&type=script&lang=js"
export * from "./symptomInof.vue?vue&type=script&lang=js"

import "./symptomInof.vue?vue&type=style&index=0&id=f37b2c38&lang=scss&scoped=scoped"

import exportComponent from "E:\\giteeWorkShowma\\hardware-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f37b2c38"]])

export default __exports__